module.exports = __webpack_public_path__ + "images/active-email-sent-4a0b054b4a44d0b361cb1b95304d256f.png";